<template>
  <v-snackbar
    multi-line
    top
    :color="notificationType"
    :value="showNotification"
    :timeout="timeout"
  >
    <slot></slot>
    <v-btn color="white" text @click="showNotification = false">
      <v-icon size="20">mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    showNotification: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Number,
      default: 4000
    },
    notificationType: {
      type: String,
      default: 'success',
      validator: value => {
        return ['success', 'warning', 'error', 'info'].indexOf(value) !== -1
      }
    }
  }
}
</script>
